import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=b37ebfee&scoped=true&"
import script from "./icon.vue?vue&type=script&lang=js&"
export * from "./icon.vue?vue&type=script&lang=js&"
import style0 from "./icon.vue?vue&type=style&index=0&id=b37ebfee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37ebfee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b37ebfee')) {
      api.createRecord('b37ebfee', component.options)
    } else {
      api.reload('b37ebfee', component.options)
    }
    module.hot.accept("./icon.vue?vue&type=template&id=b37ebfee&scoped=true&", function () {
      api.rerender('b37ebfee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon.vue"
export default component.exports